module.exports = __webpack_public_path__ + "img/logo1.0f231282.png";